<template>
    <b-link :to="to" class="text-secondary"><small><b-icon-pencil />&nbsp;ändern</small></b-link>
</template>

<script>
export default {
    props: ['to']
}
</script>